import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  deletePartnerPromotionApi,
  editPartnersPromotionsApi,
  getPartnerPromotionSettingsApi,
  getPartnersPromotionsDataApi,
  getVariantProductsApi,
  storePartnerPromotionApi,
  updatePartnerPromotionApi,
  viewPartnerPromotionApi,
  exportDifferenceDiscountReportApi,
  getDifferenceDiscountApi,
  approveDiffDiscountApi,
  declineDiffDiscountApi,
  updatePartnerPromotionProductsApi,
  deletePartnerPromotionProductsApi,
  getPriceMismatchApi,
  exportPriceMismatchReportApi,
} from "../../../services/partnerPromotion";

export const partnerProductSearch = [];

export const getDifferenceDiscount = createAsyncThunk("orders/getPartnerPromotionDifferenceDiscount", async (data, { dispatch }) => {
  const response = await getDifferenceDiscountApi(data);
  dispatch(setDifferenceDiscount(response.response));
  return response.response.data;
});

export const approveDiffDiscount = createAsyncThunk("orders/partnerPromotion/approveDiffDiscount", async (data, { dispatch }) => {
  try {
    const response = await approveDiffDiscountApi(data);
    toast.success(response.response, {
      position: toast.POSITION.TOP_RIGHT,
    });

    return response.response;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const declineDiffDiscount = createAsyncThunk("orders/partnerPromotion/declineDiffDiscount", async (data, { dispatch }) => {
  try {
    const response = await declineDiffDiscountApi(data);
    toast.success(response.response, {
      position: toast.POSITION.TOP_RIGHT,
    });

    return response.response;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const getPartnerPromotionList = createAsyncThunk("orders/getPartnerPromotionList", async (data, { dispatch }) => {
  const response = await getPartnersPromotionsDataApi(data);
  dispatch(setTableRowCount(response.response.count));
  return response.response.data;
});

export const storePartnerPromotion = createAsyncThunk("orders/storePartnerPromotion", async (promotionData, { dispatch, getState }) => {
  try {
    const response = await storePartnerPromotionApi(promotionData);
    const data = response.response;
    toast.success("New promotion added successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });

    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});
export const updatePartnerPromotion = createAsyncThunk("orders/updatePartnerPromotion", async (promotionData, { dispatch, getState }) => {
  try {
    const response = await updatePartnerPromotionApi(promotionData);
    const data = response.response;
    toast.success("Promotion updated successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });

    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updatePartnerPromotionProducts = createAsyncThunk(
  "orders/updatePartnerPromotionProducts",
  async (promotionData, { rejectWithValue }) => {
    try {
      const response = await updatePartnerPromotionProductsApi(promotionData);
      const data = response.response;

      if (!data?.success) {
        toast.error(data?.message || "Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });

        return rejectWithValue(data);
      }

      toast.success(data?.message || "Promotion Products updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });

      return data;
    } catch (e) {
      toast.error("Request failed", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return Promise.reject(e);
    }
  }
);

export const editPartnerPromotion = createAsyncThunk("orders/editPartnerPromotion", async (data, { dispatch }) => {
  const response = await editPartnersPromotionsApi(data.id, data.params);
  return response.response;
});
export const getVariantProductList = createAsyncThunk("orders/getVariantProductList", async (data, { dispatch }) => {
  const response = await getVariantProductsApi(data);
  return response.response;
});
export const viewPartnerPromotion = createAsyncThunk("orders/viewPartnerPromotion", async (data, { dispatch }) => {
  const response = await viewPartnerPromotionApi(data.id, data.params);
  return response.response;
});
export const getPartnerPromotionSettings = createAsyncThunk("orders/getPartnerPromotionSettings", async (data, { dispatch }) => {
  const response = await getPartnerPromotionSettingsApi(data);
  return response.response;
});

export const deletePartnerPromotion = createAsyncThunk("orders/deletePartnerPromotion", async (id, { dispatch }) => {
  const response = await deletePartnerPromotionApi(id);
  dispatch(getPartnerPromotionList());
  toast.success("Delete partner promotion successfully", {
    position: toast.POSITION.TOP_RIGHT,
  });
  return response.response;
});

export const exportDifferenceDiscountReport = createAsyncThunk("report/exportDifferenceDiscountReport", async (data, { dispatch }) => {
  const response = await exportDifferenceDiscountReportApi(data);
  return response.response;
});

export const deletePartnerPromotioProducts = createAsyncThunk("orders/deletePartnerPromotioProducts", async (data, { dispatch }) => {
  const response = await deletePartnerPromotionProductsApi(data);
  toast.success("Products are deleted successfully", {
    position: toast.POSITION.TOP_RIGHT,
  });
  return response.response;
});

export const getPriceMismatch = createAsyncThunk("orders/getPriceMismatch", async (data, { dispatch }) => {
  const response = await getPriceMismatchApi(data);
  dispatch(setPriceMismatch(response.response));
  return response.response.data;
});

export const exportPriceMismatcReport = createAsyncThunk("report/exportPriceMismatcReport", async (data, { dispatch }) => {
  const response = await exportPriceMismatchReportApi(data);
  return response.response;
});

const partnerPromotionAdapter = createEntityAdapter({});

export const { selectAll: selectPartnerPromotionsDiscounts, selectById: partnerPromotionsDiscountsById } = partnerPromotionAdapter.getSelectors(
  (state) => state.partnerPromotion.partnerPromotion
);

const partnersPromotionSlice = createSlice({
  name: "partnerPromotion",
  initialState: partnerPromotionAdapter.getInitialState({
    searchText: "",
    searchProduct: "",
    tableRow: 0,
    showTableRow: 0,
    productVariantIds: [],
    selectedProductVariantIds: [],
    isAllActive: false,
    productListDialogs: {
      type: 1,
      title: "",
      props: {
        isOpen: false,
      },
    },
    partnerPromotionSetting: {
      partners: [],
      users: [],
      tags: [],
      collections: [],
    },
    settings: {
      partners: [],
      users: [],
      tags: [],
      collections: [],
      discountApprovalReasons: [],
      discountDeclineReasons: [],
    },
    products: {
      data: [],
      pagination: {
        count: 0,
        next_page: 1,
        total: 0,
        has_more: false,
      },
    },
    promotions_products: {
      data: [],
      pagination: {
        count: 0,
        next_page: 1,
        total: 0,
        has_more: false,
      },
    },
    searchProductDialogProps: {
      props: {
        isOpen: false,
      },
      data: { searchValue: "" },
    },
    viewFormFilteres: {
      name: "",
      page: 1,
      pageSize: 10,
    },
    differenceDiscount: {
      data: [],
      totalRow: 0,
    },
    selectAllByFilterKey: {}, // { [filterKey]: number[] }
    activeFilterKey: null,
    productsTable: {
      pagination: {
        count: 0,
        next_page: 1,
        total: 0,
        has_more: false,
        total_items:0,
        total_products:0,
      },
    },
    priceMismatchData: {
      data: [],
      totalRow: 0,
    },
  }),
  reducers: {
    setTableRowCount: (state, action) => {
      state.tableRow = action.payload;
    },
    setViewFormFilteres: (state, action) => {
      state.viewFormFilteres = {
        ...state.viewFormFilteres,
        ...action.payload,
      };
    },
    setShowTableRowCount: (state, action) => {
      state.showTableRow = action.payload;
    },
    setPartnerPromotionSettings: (state, action) => {
      state.settings = action.payload?.setting ?? state.settings;
      state.partnerPromotionSetting = action.payload;
    },
    openProductListDialogs: (state, action) => {
      state.productListDialogs = action.payload;
    },
    setSearchProductDialog: (state, action) => {
      state.searchProductDialogProps = action.payload;
    },
    setProducts: (state, action) => {
      state.products.data = action.payload.data;
      state.products.pagination = action.payload.pagination;
    },
    setPromotionsProducts: (state, action) => {
      state.promotions_products.data = action.payload.data;
      state.promotions_products.pagination = action.payload.pagination;
    },
    setProductSearch: (state, action) => {
      state.searchProduct = action.payload;
    },
    closeProductListDialog: (state, action) => {
      state.productListDialogs = {
        type: 1,
        title: "",
        props: {
          isOpen: false,
        },
      };
    },
    setDifferenceDiscount: (state, action) => {
      state.differenceDiscount.data = action.payload.data;
      state.differenceDiscount.totalRow = action.payload.total;
    },
    setProductVariantIds: (state, action) => {
      state.productVariantIds = action.payload;
    },
    setSelectedProductVariantIds: (state, action) => {
      state.selectedProductVariantIds = action.payload;
    },
    setIsAllActive: (state, action) => {
      state.isAllActive = action.payload;
    },
    setActiveFilterKey: (state, action) => {
      state.activeFilterKey = action.payload;
    },

    storeSelectAllForFilter: (state, action) => {
      const { filterKey, ids } = action.payload;
      state.selectAllByFilterKey[filterKey] = ids;
    },

    removeSelectAllForFilter: (state, action) => {
      const { filterKey } = action.payload;
      delete state.selectAllByFilterKey[filterKey];
    },

    resetSelectAllBuckets: (state) => {
      state.selectAllByFilterKey = {};
      state.activeFilterKey = null;
    },
    setProductsTablePagination: (state, action) => {
      state.productsTable.pagination = action.payload;
    },
    setPriceMismatch: (state, action) => {
      state.priceMismatchData.data = action.payload.data;
      state.priceMismatchData.totalRow = action.payload.total;
    },
  },
  extraReducers: {
    [getPartnerPromotionList.fulfilled]: partnerPromotionAdapter.setAll,
    // [updateStaff.fulfilled]: staffsAdapter.setAll
    // [deleteStaff.fulfilled]: staffsAdapter.removeOne,
  },
});

export const {
  setTableRowCount,
  setShowTableRowCount,
  openProductListDialogs,
  closeProductListDialog,
  setSearchProductDialog,
  setProducts,
  setViewFormFilteres,
  setPartnerPromotionSettings,
  setPromotionsProducts,
  setProductSearch,
  setDifferenceDiscount,
  setProductVariantIds,
  setIsAllActive,
  setSelectedProductVariantIds,
  setActiveFilterKey,
  storeSelectAllForFilter,
  removeSelectAllForFilter,
  resetSelectAllBuckets,
  setProductsTablePagination,
  setPriceMismatch,
} = partnersPromotionSlice.actions;

export default partnersPromotionSlice.reducer;
